import {
  getDefaultSystemRoles,
  getCustomSystemRoles,
  getClientRoleModules,
  getClientRolesByClientId,
  insertCustomClientRoles,
  getAllModules,
  removeClientRoleByClientId,
  getClientUsers,
  getClientUsersHistory,
  getClientUserRoles,
  updateClientUserUnit,
  editRolesForModules,
  getAllSystemRoles,
  updateCustomClientRoles,
} from "@/api/settings";

const settings = {
  namespaced: true,
  state: () => ({
    systemRolesData: null,
    clientUserRolesOldData: null,
    clientUserRolesData: null,
    clientUsersHistoryData: null,
    clientUsersData: null,
    defaultSystemRolesObj: {
      Result: [],
      pageNumber: 1,
      pageSize: 5,
      selectedRecordCount: 0,
    },
    customSystemRolesObj: {
      Result: [],
      pageNumber: 1,
      pageSize: 5,
      selectedRecordCount: 0,
    },
    filterRecordsPerScreenOptions: [
      {
        value: 3,
        text: "3",
      },
      {
        value: 5,
        text: "5",
      },
      {
        value: 10,
        text: "10",
      },
      {
        value: 50,
        text: "50",
      },
      {
        value: 100,
        text: "100",
      },
    ],
    clientRolesModulesArr: [],
    clientDetailsForSettingsModalObj: {},
    rolesListForSettingsAddRoleArr: [],
    modulesArrForModuleComp: [],
    clientUserRolesData: null,
    clientUsersHistoryData: null,
    clientUsersData: null,
  }),
  getters: {
    getDefaultSystemRolesObj: (state) => {
      return state.defaultSystemRolesObj ? state.defaultSystemRolesObj : {};
    },
    getCustomSystemRolesObj: (state) => {
      return state.customSystemRolesObj ? state.customSystemRolesObj : {};
    },
    getFilterRecordsPerScreenOptions: (state) => {
      return state.filterRecordsPerScreenOptions;
    },
    getClientRolesModulesArr: (state) => {
      return state.clientRolesModulesArr;
    },
    getClientDetailsForSettingsModalObj: (state) => {
      return state.clientDetailsForSettingsModalObj
        ? state.clientDetailsForSettingsModalObj
        : {};
    },
    getRolesListForSettingsAddRoleArr: (state) => {
      return state.rolesListForSettingsAddRoleArr
        ? state.rolesListForSettingsAddRoleArr
        : [];
    },
    getModulesArrForModuleComp: (state) => {
      return state.modulesArrForModuleComp.length > 0
        ? state.modulesArrForModuleComp
        : [];
    },
  },
  actions: {
    fetchDefaultSystemRoles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getDefaultSystemRoles(payload)
          .then((roles) => {
            if (roles.status === 200 && roles.data.Result != null) {
              commit("SET_DEFAULT_SYSTEM_ROLES_OBJ", roles.data);
            } else {
              commit("SET_DEFAULT_SYSTEM_ROLES_OBJ", {
                Result: [],
                pageNumber: 1,
                pageSize: 3,
                selectedRecordCount: 0,
              });
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from fetchDefaultSystemRoles settings store");
          });
      });
    },
    fetchCustomSystemRoles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getCustomSystemRoles(payload)
          .then((roles) => {
            if (roles.status === 200 && roles.data.Result != null) {
              commit("SET_CUSTOM_SYSTEM_ROLES_OBJ", roles.data);
            } else {
              commit("SET_CUSTOM_SYSTEM_ROLES_OBJ", {
                Result: [],
                pageNumber: 1,
                pageSize: 3,
                selectedRecordCount: 0,
              });
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from fetchDefaultSystemRoles settings store");
          });
      });
    },
    fetchClientRoleModules({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getClientRoleModules(payload)
          .then((roles) => {
            if (roles.status === 200) {
              commit("SET_CLIENT_ROLES_MODULES_ARR", roles.data);
            } else {
              commit("SET_CLIENT_ROLES_MODULES_ARR", []);
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from fetchClientRoleModules");
          });
      });
    },
    fetchClientRolesByClientId({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getClientRolesByClientId(payload)
          .then((roles) => {
            if (roles.status === 200) {
              commit("SET_ROLES_LIST_SETTINGS_FOR_ADD_ROLE", roles.data);
            } else {
              commit("SET_ROLES_LIST_SETTINGS_FOR_ADD_ROLE", []);
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from fetchClientRolesByClientId store");
          });
      });
    },
    addCustomClientRoles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        insertCustomClientRoles(payload)
          .then((output) => {
            if (output.status === 200) {
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from addCustomClientRoles store");
          });
      });
    },
    fetchAllModules({ commit }) {
      return new Promise((resolve, reject) => {
        getAllModules()
          .then((modules) => {
            if (modules.status === 200) {
              commit("SET_MODULES_ARR_FOR_MODULE_COMP", modules.data);
            } else {
              commit("SET_MODULES_ARR_FOR_MODULE_COMP", []);
            }

            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from fetchAllModules store");
          });
      });
    },
    deleteClientRoleByClientId({ commit }, payload) {
      return new Promise((resolve, reject) => {
        removeClientRoleByClientId(payload)
          .then((output) => {
            if (output.status === 200) {
            } else {
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from deleteClientRoleByClientId store");
          });
      });
    },
    getClientUsers({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getClientUsers(payload)
          .then((data) => {
            commit("SET_CLIENT_USERS", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getClientUsers");
          });
      });
    },
    getClientUsersHistory({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getClientUsersHistory(payload)
          .then((data) => {
            commit("SET_CLIENT_USERS_HISTORY", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getClientUsersHistory");
          });
      });
    },
    getClientUserRoles({ commit }, params) {
      return new Promise((resolve, reject) => {
        getClientUserRoles(params)
          .then((data) => {
            commit("SET_CLIENT_USER_ROLES", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getClientUserRoles");
          });
      });
    },
    updateClientUserUnit({ commit }, payload) {
      return new Promise((resolve, reject) => {
        updateClientUserUnit(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateClientUserUnit");
          });
      });
    },
    updateRolesForModules({ commit }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        editRolesForModules(payload)
          .then((output) => {
            if (output.status === 200) {
            } else {
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
            console.log("error from updateRolesForModules");
          });
      });
    },

    getAllSystemRoles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getAllSystemRoles(payload)
          .then((data) => {
            commit("SET_SYSTEM_ROLES_DATA", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getAllSystemRoles");
          });
      });
    },

    editCustomClientRoles({ commit }, payload) {
      return new Promise((resolve, reject) => {
        updateCustomClientRoles(payload)
          .then((result) => {
            resolve(result);
          })
          .catch((err) => {
            reject(err);
            console.log("error from editCustomClientRoles store");
          });
      });
    },
  },
  mutations: {
    SET_DEFAULT_SYSTEM_ROLES_OBJ: (state, data) => {
      state.defaultSystemRolesObj = data;
    },
    SET_CUSTOM_SYSTEM_ROLES_OBJ: (state, data) => {
      state.customSystemRolesObj = data;
    },
    SET_CLIENT_ROLES_MODULES_ARR: (state, data) => {
      state.clientRolesModulesArr = data;
    },
    SET_SETTINGS_MODAL_DETAILS_BY_ID: (state, data) => {
      state.clientDetailsForSettingsModalObj = data;
    },
    SET_ROLES_LIST_SETTINGS_FOR_ADD_ROLE: (state, data) => {
      state.rolesListForSettingsAddRoleArr = data;
    },
    SET_MODULES_ARR_FOR_MODULE_COMP: (state, data) => {
      state.modulesArrForModuleComp = data;
    },
    SET_CLIENT_USERS: (state, data) => {
      state.clientUsersData = data;
    },
    SET_CLIENT_USERS_HISTORY: (state, data) => {
      state.clientUsersHistoryData = data;
    },
    SET_CLIENT_USER_ROLES: (state, data) => {
      state.clientUserRolesData = data.map((client) => {

        if (client.client_user_units === null) {
          client.client_user_units = [client.id];
        }

        const participant_role_id = client.client_roles.filter((role) => {
          if (role.clientRoleName === "Participant") {
            return role;
          }
        });
        client.participant_role_id = participant_role_id[0].clientRoleId;

        client.client_role_name_old = client.client_role_name;
        client.client_role_id_old = client.client_role_id;
        
        return client;
      });
    },
    SET_SYSTEM_ROLES_DATA: (state, data) => {
      state.systemRolesData = data;
    },
  },
};

export default settings;
